export const languageTempletsOptions = [
    { label: 'Arabic', value: "ar" },
    { label: 'Deutsch', value: "de" },
    { label: 'Dutch', value: "nl" },
    { label: 'Dutch II', value: "nlII" },
    { label: 'English', value: "en" },
    { label: 'Polish', value: "pl" },
    { label: 'Portogees', value: "pt" },
    { label: 'Romanian', value: "ro" },
    { label: 'Spanish', value: "es" },
]